/**
 * Recursively converts the keys of an object or array to snake_case.
 * @param input - The object, array, or value to process.
 * @returns The input with all keys converted to snake_case.
 */
export const snakeCaseKeys = (obj: unknown): unknown => {
  if (typeof obj !== 'object' || obj === null) {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map(snakeCaseKeys);
  }

  return Object.keys(obj as Record<string, unknown>).reduce(
    (acc: Record<string, unknown>, key: string) => {
      const snakeCaseKey = key.replace(/[A-Z]/g, (match) => `_${match.toLowerCase()}`);
      const value = (obj as Record<string, unknown>)[key];
      acc[snakeCaseKey] = snakeCaseKeys(value);
      return acc;
    },
    {} as Record<string, unknown>
  );
};
